type ArLoadingBannerProps = {
	isLoading: boolean;
};

/**
 * Small translucent pill that takes the AR button's place while the AR model
 * is being prepared.
 */
export const ArLoadingBanner = ({ isLoading }: ArLoadingBannerProps): React.ReactElement | null => {
	if (!isLoading) return null;

	return (
		<div
			role="status"
			aria-live="polite"
			style={{
				position: 'absolute',
				top: '12px',
				right: '12px',
				height: '40px',
				padding: '0 14px 0 12px',
				display: 'flex',
				alignItems: 'center',
				gap: '8px',
				borderRadius: '20px',
				border: '1px solid rgba(0, 0, 0, 0.08)',
				backgroundColor: 'rgba(255, 255, 255, 0.85)',
				backdropFilter: 'blur(10px)',
				WebkitBackdropFilter: 'blur(10px)',
				boxShadow: '0 1px 4px rgba(0, 0, 0, 0.12)',
				color: '#1f2328',
				fontSize: '13px',
				fontWeight: 500,
				zIndex: 150,
				fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
				whiteSpace: 'nowrap'
			}}
		>
			<div
				style={{
					width: '16px',
					height: '16px',
					border: '2px solid rgba(0, 0, 0, 0.15)',
					borderTopColor: '#1f2328',
					borderRadius: '50%',
					animation: 'spin 0.8s linear infinite',
					flexShrink: 0
				}}
			/>
			<span>Preparing AR…</span>
		</div>
	);
};
